import { zafClient } from '@/services/zendesk'
import type { VtexInteraction, VtexOrder } from '@/interfaces'
import type { ZafMetadata } from '@/interfaces'
import type { DocumentMasterData } from '@/interfaces/masterData'

export type { VtexOrder }

export async function getVtexOrder(orderId: string): Promise<VtexOrder> {
  if (!zafClient) throw new Error('ZAF client not available')

  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const { vtexAppSubdominio, vtexAppKey, vtexAppToken } = meta.settings

  const order = await zafClient.request({
    url: `https://${vtexAppSubdominio}.myvtex.com.br/api/oms/pvt/orders/${orderId}`,
    type: 'GET',
    headers: {
      'X-VTEX-API-AppKey': vtexAppKey,
      'X-VTEX-API-AppToken': vtexAppToken,
    },
    dataType: 'json',
  }) as VtexOrder

  return order
}

export async function getVtextInteractions(orderId: string) {
  if (!zafClient) throw new Error('ZAF client not available')
    
  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const { vtexAppSubdominio, vtexAppKey, vtexAppToken } = meta.settings

  const interactions = await zafClient.request({
    url: `https://${vtexAppSubdominio}.vtexcommercestable.com.br/api/oms/pvt/orders/${orderId}/interactions`,
    type: 'GET',
    headers: {
      'X-VTEX-API-AppKey': vtexAppKey,
      'X-VTEX-API-AppToken': vtexAppToken,
    },
    dataType: 'json',
  }) as VtexInteraction[]

  return interactions
}

export async function getVtexDocument(cpf: string) {
  if (!zafClient) throw new Error('ZAF client not available')

  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const { vtexAppSubdominio, vtexAppKey, vtexAppToken } = meta.settings

  const document = await zafClient.request({
    url: `https://${vtexAppSubdominio}.vtexcommercestable.com.br/api/dataentities/CL/search?_where=document=${cpf}`,
    type: 'GET',
    headers: {
      'Accept': 'application/vnd.vtex.ds.v10+json',
      'Content-Type': 'application/json',
      'X-VTEX-API-AppKey': vtexAppKey,
      'X-VTEX-API-AppToken': vtexAppToken,
    },
    dataType: 'json',
  }) as DocumentMasterData[]

  return document
}